// *******************************************************************************
// Form : Step Form
// *******************************************************************************
const stepFormElem = document.querySelector('.step-form');

if (stepFormElem) {
  const handleStepForm = (form, formAction) => {
    const studyId = form.querySelector('[data-study-id]').value;
    const formParent = form.closest('[data-step-form-parent]');
    const allFormSteps = formParent.querySelectorAll('.step-form__step');
    const allStepIndicator = formParent.querySelectorAll('.step-form__indicator-btn');
    const nextButton = formParent.querySelector('.step-form__next-step');
    const nextButtonTextElem = nextButton.querySelector('.btn__text');
    const prevButton = formParent.querySelector('.step-form__prev-step');
    const submitButtonText = nextButton.getAttribute(['data-submit-text']);
    const formAlertError = formParent.querySelector('.step-form__alert-error');
    const nextButtonText = nextButtonTextElem.innerHTML;
    const allForms = [];
    const allStepData = [];
    const allStepRequiredData = [];
    let currentStepIndex = 0;

    const toggleStep = (index, active) => {
      const step = allFormSteps[index];
      const stepIndicator = allStepIndicator[index];

      FormValidation.utils.classSet(step, {
        'is-active': active,
      });
      FormValidation.utils.classSet(stepIndicator, {
        'is-active': active,
      });
      FormValidation.utils.classSet(stepIndicator, {
        'is-completed': active,
      });
    };

    const markCompleted = (index) => {
      // const stepIndicator = allStepIndicator[index];
      // stepIndicator.classList.add('is-completed');

      allStepIndicator.forEach((item, i) => {
        if (i <= index) {
          item.classList.add('is-completed');
        }
      });
    };

    const moveNextStep = async (e) => {
      e.target.disabled = true;
      if (currentStepIndex < allForms.length) {
        const currentForm = allForms[currentStepIndex];
        const status = await currentForm.validate();
        if (status !== 'Valid') {
          e.target.disabled = false;
          return;
        }

        let nextIndex = currentStepIndex + 1;

        while (nextIndex < allFormSteps.length && allFormSteps[nextIndex].classList.contains('hide')) {
          nextIndex++;
        }

        if (nextIndex < allFormSteps.length) {
          toggleStep(currentStepIndex, false);
          currentStepIndex = nextIndex;
          toggleStep(currentStepIndex, true);
          prevButton?.classList.remove('hide');
        }

        if (currentStepIndex === allFormSteps.length - 1) {
          nextButtonTextElem.innerHTML = submitButtonText;
        }

        scrollTop(formParent);
      }
      e.target.disabled = false;
    };

    const moveBackStep = (e) => {
      e.target.disabled = true;

      if (currentStepIndex > 0) {
        allStepIndicator.forEach((indicator) => indicator.classList.remove('is-active'));

        toggleStep(currentStepIndex, false);
        currentStepIndex--;
        toggleStep(currentStepIndex, true);

        if (currentStepIndex === 0) {
          prevButton?.classList.add('hide');
        }

        nextButtonTextElem.innerHTML = nextButtonText;
        scrollTop(formParent);
      }

      e.target.disabled = false;
    };

    allFormSteps.forEach((step, index) => {
      const { fieldValidators, uploadBox } = getCustomValidators(step);

      const fv = FormValidation.formValidation(step, {
        locale: 'sl_SI',
        localization: FormValidation.locales.sl_SI,
        fields: fieldValidators,
        plugins: {
          message: new FormValidation.plugins.Message({
            container: (field, element) =>
              element.closest('.mod-input,.checkbox,.radio-button,.dropdown,.mod-toggle,.upload-box__inner'),
          }),
          declarative: new FormValidation.plugins.Declarative({
            html5Input: true,
          }),
          trigger: new FormValidation.plugins.Trigger({
            event: 'submit',
          }),
          excluded: new FormValidation.plugins.Excluded(),
          submitButton: new FormValidation.plugins.SubmitButton(),
        },
      });

      if (uploadBox) {
        fv.registerValidator('checkMaxFiles', fileCountValidator);
        fv.registerValidator('checkFilesSize', fileSizeValidator);
        fv.registerValidator('checkFilesType', fileTypeValidator);

        uploadBox.addEventListener('change', () => fv.revalidateField(uploadBox?.name));
        uploadBox.addEventListener('fileRemoved', () => fv.revalidateField(uploadBox?.name));
      }

      fv.on('core.element.validated', (e) => {
        const { valid: isValid, field, element } = e;

        if (field.includes('payment_method')) {
          const parent = element.closest('.payment-method');
          if (parent) {
            const inputs = parent.querySelectorAll('.radio-button');
            inputs.forEach((input) => setFormError(input, !isValid));
          }
        } else {
          const container = FormValidation.utils.closest(
            element,
            '.mod-input,.checkbox,.radio-button,.dropdown,.mod-toggle,.upload-box__inner',
          );

          if (container) {
            const value = fv.getElementValue(field, element);

            // const isUploadBox = container.classList.contains('upload-box__main');
            const uploadInput = container.querySelector('.upload-box__input');
            const valueInvalid = uploadInput?.hasAttribute('required') && (!value || value.length === 0);

            const fieldInvalid = valueInvalid || !isValid;
            setFormError(container, fieldInvalid);
          }
        }

        const firstFailedField = formParent.querySelector('.step-form__step.is-active .is-validation-failed');
        if (firstFailedField) scrollTop(firstFailedField);
      });

      fv.on('core.form.valid', () => {
        grecaptcha.ready(async () => {
          formParent.classList.add('show-loader');
          let response;

          try {
            const stepData = getFormValue(step, fv);
            const stepDataInputs = JSON.parse(stepData.inputs);
            const stepDataRequiredInputs = JSON.parse(stepData.requiredInputs);
            parseCloneKeys(stepDataInputs, step);
            parseCloneKeys(stepDataRequiredInputs, step);

            allStepRequiredData[index] = stepDataRequiredInputs;
            allStepData[index] = stepDataInputs;

            const inputs = {};
            const requiredInputs = {};

            const formType = form.getAttribute('id');

            // if (index < allFormSteps.length - 1) {
            // stepFormGTMDataLayer(index, stepData.inputs, formType, 'form_step');
            // }

            if (index === allFormSteps.length - 2) {
              const isFree = form.getAttribute('free-study') === 'true';
              ['payment-method', 'price-summary', 'highlighted-box'].forEach((key) => {
                const element = allFormSteps[index + 1].querySelector(`.${key}`);
                const parent = element?.closest('.step-form__item');

                parent?.classList.toggle('hide', key === 'highlighted-box' ? !isFree : isFree);
              });
            }

            if (index === allFormSteps.length - 1) {
              // stepFormGTMDataLayer(index, stepData.inputs, formType, 'form_submit');
              const paymentMethod = step.querySelector('.payment-method input:checked');

              if (paymentMethod) {
                const paymentValue = paymentMethod.value;
                allStepRequiredData[index][paymentMethod.getAttribute('name')] = paymentValue;
                allStepData[index][paymentMethod.getAttribute('name')] = paymentValue;
              } else {
                const getPaymentId = step.querySelector('.payment-method input');
                if (getPaymentId) {
                  allStepRequiredData[index][getPaymentId.getAttribute('name')] = 'free-token';
                  allStepData[index][getPaymentId.getAttribute('name')] = 'free-token';
                }
              }

              for (const key in allStepData) {
                if (!isNaN(key)) {
                  Object.assign(inputs, allStepData[key]);
                }
              }

              for (const key in allStepRequiredData) {
                if (!isNaN(key)) {
                  Object.assign(requiredInputs, allStepRequiredData[key]);
                }
              }

              const files = {};
              Array.from(filesToUpload).forEach((file, index) => {
                const { file: fileData, ...additionalData } = file;

                inputs[`files_${index + 1}_${additionalData.parentId}_info`] = additionalData;
                files[`files_${index + 1}_${additionalData.parentId}`] = fileData;
              });

              response = await onFormSubmit({
                formData: {
                  ...files,
                  inputs: JSON.stringify(inputs),
                  requiredInputs: JSON.stringify(requiredInputs),
                  lang: localData.lang,
                  id: localData.id,
                  formType,
                  studyId,
                },
                recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
                recaptchaAction: formAction,
              });
            }

            const cardPayment = formParent.querySelector('[data-payment-card]');

            if (index === allFormSteps.length - 1) {
              const clientSecret = response?.data?.data?.client_secret;

              if (cardPayment?.checked) {
                if (clientSecret) {
                  initializeStripe(clientSecret);
                  formParent.classList.add('show-payment-screen');
                  formParent.classList.remove('show-loader');
                  return;
                }
                formParent.classList.remove('show-loader');
                formParent.classList.add('show-error');

                if (formAlertError) {
                  formAlertError.classList.remove('hide');
                  const textContainer = formAlertError.querySelector('p');
                  textContainer.textContent = 'Prišlo je do napake pri nalaganju STRIP modula.';
                }
                return;
              }

              const isFree = form.getAttribute('free-study') === 'true';

              if (isFree) {
                formParent.classList.add('show-free-thankyou');
              } else {
                formParent.classList.add('show-default-thankyou');
              }
            } else {
              toggleStep(index, false);
              if (index + 1 < allFormSteps.length) {
                toggleStep(index + 1, true);
              }
            }

            formParent.classList.remove('show-loader');
            markCompleted(index);
          } catch (error) {
            formParent.classList.remove('show-loader');
            formParent.classList.add('show-error');

            if (!formAlertError) return;
            formAlertError.classList.remove('hide');
            const textContainer = formAlertError.querySelector('p');
            textContainer.textContent = error.message ?? error?.response.data.data.msg;
          }
        });
      });

      attachEvent('.clone-input__add-more .btn', 'click', (btn) => {
        const parent = btn.target.closest('.clone-input');
        const lastAddedRow = parent.querySelector('.last-added');

        const inputs = lastAddedRow?.querySelectorAll('input');

        inputs?.forEach((input) => {
          const field = input.getAttribute('data-fv-name');
          fv.addField(field);
        });
      });

      allForms.push(fv);
    });

    nextButton.addEventListener('click', moveNextStep);
    prevButton?.addEventListener('click', moveBackStep);

    attachEvent('.order-color-study .detail-modal .btn', 'click', (btn) => {
      const parentEle = btn.target.closest('.detail-modal');
      parentEle.classList.remove('is-open-modal');

      form.setAttribute('free-study', 'true');
    });

    attachEvent('.payment-submit-btn', 'click', async (btn) => {
      btn.preventDefault();
      btn.target.disabled = true;
      await handleSubmitStripe(btn);
      btn.target.disabled = false;
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    ['order_color_study', 'additional_info_form', 'step_form'].forEach((id) => {
      const form = document.querySelector(`#${id}`);
      if (form !== null) {
        const formAction = form.querySelector('[data-action]').value;
        handleStepForm(form, formAction, id);
      }
    });
  });

  ['order_color_study', 'additional_info_form', 'step_form'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      window.addEventListener('pageshow', (event) => {
        const navigationEntries = performance.getEntriesByType('navigation');
        if (
          event.persisted ||
          (window.performance && navigationEntries.length > 0 && navigationEntries[0].type === 'back_forward')
        ) {
          window.location.reload();
        }
      });
    }
  });

  attachEvent('[action="searchVatNumber"]', 'click', (vatBtn) => {
    const container = vatBtn.target.closest('.info-tab__search');
    const noResult = container.querySelector('.info-tab__search-no-result');
    const companyInfo = container.querySelector('.info-tab__company');

    noResult.classList.add('hide');

    const vatInput = document.getElementById('business_profile_tax_id');
    const vat = vatInput.value;

    axiosGetCompanyByVat(vat, noResult, companyInfo);
  });

  const axiosGetCompanyByVat = async (vat, noResult, companyInfo) => {
    const fields = {
      name: companyInfo.querySelector('[name="order_color_study_form_step_1_business_profile_company"]'),
      address: companyInfo.querySelector('[name="order_color_study_form_step_1_business_profile_street"]'),
      zip: companyInfo.querySelector('[name="order_color_study_form_step_1_business_profile_postal_code"]'),
      city: companyInfo.querySelector('[name="order_color_study_form_step_1_business_profile_city"]'),
    };

    Object.values(fields).forEach((input) => (input.value = ''));

    try {
      const { data, status } = await axios.post(localData.siteURL, {
        action: 'searchVatNumber',
        vat,
      });

      if (status === 204 || !data?.data) {
        noResult.classList.remove('hide');
        return;
      }

      const { company, address, zip, city } = data.data;
      Object.assign(fields.name, { value: company ?? '' });
      Object.assign(fields.address, { value: address ?? '' });
      Object.assign(fields.zip, { value: zip ?? '' });
      Object.assign(fields.city, { value: city ?? '' });

      const infoTabSearch = companyInfo.closest('.info-tab__search');
      if (infoTabSearch) {
        scrollTop(infoTabSearch);
      }
    } catch (error) {
      noResult.classList.remove('hide');
    }
  };

  // Email Check
  const emailEle1 = document.querySelector('#order_color_study_form_step_1_individual_profile_verify_email');
  const emailEle2 = document.querySelector('#order_color_study_form_step_1_business_profile_verify_email');

  [emailEle1, emailEle2].forEach((emailEle) => {
    emailEle?.addEventListener('blur', (ev) => {
      const inputValue = ev.target.value.trim();

      if (inputValue) {
        axiosGetEmailInfo(inputValue);
      }
    });
  });

  attachEvent('.checkbox-multiple__list-item #notification-terms', 'change', (termsBtn) => {
    const checkbox = termsBtn.target;

    const smsCheckbox = stepFormElem.querySelector('.checkbox-multiple__list-item #sms-terms');
    const emailCheckbox = stepFormElem.querySelector('.checkbox-multiple__list-item #email-terms');

    [smsCheckbox, emailCheckbox].forEach((cb) => {
      if (!cb) return;

      cb.checked = checkbox.checked;
      cb.disabled = checkbox.checked;
    });
  });

  // Email Check
  // const emailEle = document.querySelectorAll('[data-identical-field]');
  // emailEle.forEach((ele) => {
  //   ele.addEventListener('blur', (ev) => {
  //     const inputValue = ev.target.value.trim();
  //     axiosGetEmailInfo(inputValue);
  //   });
  // });
}
